import type {
  ReviewRequest,
  UsersReviewRequest,
  UsersReviewsRequest,
} from "../types";

const reviewKeys = {
  base: ["reviews"] as const,
  lists: () => [...reviewKeys.base, "list"] as const,
  infinite: (params: ReviewRequest) =>
    [...reviewKeys.lists(), "infinite", params] as const,
  usersList: (params: UsersReviewsRequest) =>
    [...reviewKeys.lists(), "usersList", params] as const,
  badgeList: (badge: string) =>
    [...reviewKeys.lists(), "badge", badge] as const,
  details: () => [...reviewKeys.base, "detail"] as const,
  detail: (params: UsersReviewRequest) =>
    [...reviewKeys.details(), params] as const,
};

export { reviewKeys };
